import { isObject } from "./utils";
import { IUserToken } from "../components/shared/types";

const PROTOCOL = 'https:'; //window.location.protocol;
const HASH = window.location.hash;
export const APP_HOST = !window.location.host.match(/^localhost/i) ? window.location.host :
             HASH.match(/^#ecoplant|^#rice/i) ? 'gisagro.gistda.or.th' : 'gisagro.gistda.or.th';
export const APP_URL = PROTOCOL + '//' + APP_HOST;
export const HALLO_WEBSOCKET = (PROTOCOL.match(/^https:$/i) ? 'wss' : 'ws') + '://' + APP_HOST + '/hallo/';
export const CALENDAR_URL = APP_URL; // + '/calendar';
export const HEADER_TOKEN = 'Token';
export const HEADER_BEARER = 'Bearer';
export const HEADER_AUTH = 'Authorization';
export const HEADER_CONTENT_TYPE = 'Content-Type';
export const APIID = 'th.co.softoo.rest';
export const APPKEY = ''; //reserved
//export let USER_TOKEN:IUserToken;

let USER_TOKEN : IUserToken = {
  hallo: null, // string; //used to login to websocket
  access: {
    token: null, // string;
    expire: null // number;
  },
  refresh: {
    token: null, // string;
    expire: null //number;
  }
}

export interface IRequestOption extends RequestInit {
  user?: any,
  fake?: string;
  fakeOption?: any;
}

export const urls = {
  codelist: {
    url: APP_URL + '/rest/codelist',
    token: ''
  },
  user: {
    url: APP_URL + '/rest/user',
    token: ''
  },
  request: {
    url: APP_URL + '/rest',
    token: ''
  },
  serviceProvider: {
    url: APP_URL + '/rest/',
    token: ''
  },
  contact: {
    url: APP_URL + '/rest/',
    token: ''
  },
  chat: {
    url: APP_URL + '/rest/',
    token: ''
  },
  news: {
    url: APP_URL + '/rest/',
    token: ''
  },
  gis: {
    url: APP_URL + '/rest/gis/',
    token: ''
  },
  idc: {
    url:'https://gist.githubusercontent.com/Goles/3196253/raw/9ca4e7e62ea5ad935bb3580dc0a07d9df033b451/CountryCodes.json',
    token: ''
  }
}

class HttpError extends Error {
  status?: number;
  id?: string;
  url?: string;
  constructor(httpError={}, message:string) {
    super(message);
    this.name = this.constructor.name;
    this.message = message || 'Unknow Error';
    if (httpError['status']) {
      this.status = httpError['status'];
    }
    if (httpError['id']) {
      this.id = httpError['id'];
    }
    if (httpError['url']) {
      this.url = httpError['url'];
    }
  }
}

/**
 * get data as a json object
 * 
 * @param url 
 * @param options 
 */
export async function request(url:string, options?:IRequestOption) {
  try {
    options = options || {};
    let user = options.user;
    if (user) {
      delete options.user
    }
    options.headers = Object.assign({
      'Content-Type': 'application/json'
    }, options.headers || {});
    if (url.indexOf(APP_URL)==0) {
      options.headers['X-Requested-With'] = APIID;
      if (USER_TOKEN.access.token && !options.headers[HEADER_AUTH]) {
        options.headers[HEADER_AUTH] = HEADER_BEARER + ' ' + USER_TOKEN.access.token;
      }
    }
    let isJson = !!options.headers['Content-Type'].match(/\/json$/i);
    let isBlob = !!options.headers['Content-Type'].match(/^image\//i);
    if (!!options.headers['Content-Type'].match(/\/x-www-form-urlencoded$|DELETE_ME/i)) {
      delete options.headers['Content-Type'];
      isJson = true;
    }
    let response = await fetch(url, options)
    .then(handleErrors)
    .then((response) => {
      return response;
    });
    let data;
    if(isJson) {
      data = await response.json();
      if (data && isObject(data) && data.id && data.message && data.status && data.status!=200) {
        // response.ok = false; // ok is read-only property
        throw new HttpError(data, data.message)
      }
      if (data && data.token && (data.token.hallo || (data.token.refresh && data.tolen.access))) {
        USER_TOKEN = data.token;
      } else if (data && data.loggedout) {
        USER_TOKEN = {
          hallo: null,
          access: {
            token: null,
            expire: null
          },
          refresh: {
            token: null,
            expire: null
          }
        };
      }
    } else if (isBlob) {
      data = await response.blob();
    } else {
      data = await response.text();
    }
    return data;
  } catch (error) {
    throw(error);
  }
}

async function handleErrors(response) {
  if (!response.ok) {
    let err;
    try {
      err = await response.json();
    } catch (error) {
      err = {
        status: response.status,
        message: error.message || response.statusText || 'Error: ' + response.url
      }
    }
    throw new HttpError({status:err.status}, err.message);
  }
  return response;
}

export function updateToken(token) {
  USER_TOKEN = token || {
    hallo: null, // string; //used to login to websocket
    access: {
      token: null, // string;
      expire: null // number;
    },
    refresh: {
      token: null, // string;
      expire: null //number;
    }
  };
}

export default {
  urls: urls,
  request: request
}